import { useLocation, useParams } from 'react-router-dom'

import { Trans } from '@/components'

import { ResourcePermissionPage } from '../components/ResourcePermissionPage'

type LocState = { member?: any; username?: string }

export function TeamMemberPermissionPage() {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  const state = (location.state ?? {}) as LocState
  const userName = state.username

  if (!id) return <div>Not found</div>

  return (
    <ResourcePermissionPage
      scope="member"
      resId={id}
      backTo={`/team/member/${id}`}
      titleTrail={
        <span>
          {' '}
          <Trans i18nKey="team.member.title">Member</Trans> / {userName} /{' '}
        </span>
      }
    />
  )
}
